import React from "react";
import {
  HiCalendarDays,
  HiClock,
  HiDocumentText,
  HiQuestionMarkCircle,
} from "react-icons/hi2";
import MainButton, {
  CancelButton,
  DeleteButton,
  EditButton,
  PublishButton,
  ViewButton,
} from "../../components/common/MainButtonComponent";
import "./AssessShared.css";

const getStatusClass = (status) => {
  const key = (status || "").toLowerCase().replace(/\s+/g, "-");
  return `assess-status assess-status--${key}`;
};

const parseUtcTimestamp = (value) => {
  if (value instanceof Date) return value;
  if (typeof value !== "string") return new Date(value);

  const normalized = value.trim();
  if (!normalized) return new Date(NaN);

  if (/[zZ]$|[+-]\d{2}:?\d{2}$/.test(normalized)) {
    return new Date(normalized);
  }

  const isoLike = normalized.replace(" ", "T").replace(/\.(\d{3})\d+$/, ".$1");
  return new Date(`${isoLike}Z`);
};

const formatRelativeTime = (value) => {
  if (!value) return "";

  const createdAt = parseUtcTimestamp(value);
  if (Number.isNaN(createdAt.getTime())) return "";

  const diffMs = Date.now() - createdAt.getTime();
  const isFuture = diffMs < 0;
  const diffSeconds = Math.floor(Math.abs(diffMs) / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffWeeks = Math.floor(diffDays / 7);

  const withDirection = (amount, unit) =>
    isFuture ? `in ${amount} ${unit}` : `${amount} ${unit} ago`;

  if (diffSeconds < 60) return `just now`;
  if (diffMinutes < 60) return withDirection(diffMinutes, `min${diffMinutes === 1 ? "" : "s"}`);
  if (diffHours < 24) return withDirection(diffHours, `hour${diffHours === 1 ? "" : "s"}`);
  if (diffDays < 7) return withDirection(diffDays, `day${diffDays === 1 ? "" : "s"}`);
  return withDirection(diffWeeks, `week${diffWeeks === 1 ? "" : "s"}`);
};

export default function AssessmentCard({
  activeTab,
  item,
  onView,
  onEdit,
  onDelete,
  onSetup,
  onPublish,
  onCancelPublish,
}) {
  const isPublished = ((item?.status) || "").toLowerCase() === "published";
  return (
    <article className="assess-card row g-2 align-items-center">
      <div className="col-auto">
        <div className="assess-card__icon">
          <HiDocumentText aria-hidden="true" />
        </div>
      </div>

      <div className="assess-card__content col-12 col-lg">
        <div className="assess-card__title-row">
          <h3 className="assess-card__title">{item.name}</h3>
          <span className={getStatusClass(item.status)}>{item.status}</span>
          <h3 className="assess-card__title">ASMNT{item.assessment_id}</h3>
        </div>

        <div className="assess-card__meta">
          <span>
            <HiClock aria-hidden="true" />
            {formatRelativeTime(item.created_at || item.createdAt)}
          </span>
          <span>
            <HiCalendarDays aria-hidden="true" />
            {item.createdAt}
          </span>
          {item.ismaster !== undefined && (
            <span className="assess-card__meta-item">
              {item.ismaster ? "Master paper" : "Part of multi-paper"}
            </span>
          )}
          {item.parent_assessment_id && (
            <span className="assess-card__meta-item">Parent: {item.parent_assessment_title}</span>
          )}
          {/* <span>
            <HiQuestionMarkCircle aria-hidden="true" />
            {item.questions} items
          </span> */}
        </div>
      </div>

      <div className="assess-card__divider col-12" aria-hidden="true" />

      <div className="assess-card__right col-12 col-lg-auto">
        {/* <div className="assess-card__publish">
          <div className="assess-card__publish-actions">
            {(item.status).toLowerCase() == "ready" && (
              <PublishButton
                label="Publish"
                title="Publish Assessment"
                onClick={() => onPublish?.(item)}
              />
            )}

            {(item.status).toLowerCase() == "published" && (
              <CancelButton
                label="Remove From Publish"
                title="Cancel Publish"
                onClick={() => onCancelPublish?.(item)}
              />
            )}
          </div>
        </div> */}

        <div className="assess-card__actions">
          <ViewButton label="" title="View" onClick={() => onView(item)} />
          {!isPublished && (
            <EditButton label="" title="Edit" onClick={() => onEdit(item)} />
          )}
          {onSetup && (
            <MainButton
              action="setup"
              icon="setup"
              tone="neutral"
              label=""
              title="Setup Assessment"
              onClick={() => onSetup(item)}
            />
          )}
          {activeTab === "my" && !isPublished && (
            <DeleteButton label="" title="Delete" onClick={() => onDelete(item)} />
          )}
        </div>
      </div>
    </article>
  );
}
